// deps
import React, { memo, ReactElement, useCallback } from "react";

// components
import { UPICancelAlert, UPINote } from "../components";
import { TickScreen } from "@payment-ui/components/tick-screen";

// test-ids
import { UPI_INTENT_TEST_IDS } from "@swiggy-private/payment-test-ids";

// styles
import styles from "../styles.scss";

// types
import { TickScreenProps } from "@payment-ui/components/tick-screen/interfaces";

//helpers
import { isJioHotstarFlow } from "@swiggy-private/checkout-core";

interface UpiIntentPollerProps extends TickScreenProps {
    showCancelModal: boolean;
    setShowCancelModal: (show: boolean) => void;
    onCancelTransaction: VoidFunction;
    paymentAmount: string;
    itemCount?: number;
}

function UpiIntentPoller(props: UpiIntentPollerProps): ReactElement {
    const { setShowCancelModal, onCancelTransaction } = props;
    const isJioHotstar = isJioHotstarFlow();

    const onSecondaryActionClick = useCallback((): void => {
        setShowCancelModal(false);
    }, [setShowCancelModal]);

    return (
        <>
            <div className={styles.container} data-testid={UPI_INTENT_TEST_IDS.CONTAINER}>
                <div className={styles.containerContent}>
                    <TickScreen
                        tickState={props.tickState}
                        mainText={props.mainText}
                        subText={props.subText}
                        isSuper={props.isSuper}
                        isSwiggyMoney={props.isSwiggyMoney}
                        accent={props.accent}
                        isStealStoreCart={props.isStealStoreCart}
                        isJioHotstarFlow={isJioHotstar}
                    />
                    <UPINote isIntent={true} isJioHotstarFlow={isJioHotstar} />
                </div>
            </div>
            <UPICancelAlert
                onCancelTransaction={onCancelTransaction}
                onSecondaryActionClick={onSecondaryActionClick}
                paymentAmount={props.paymentAmount}
                itemCount={String(props.itemCount)}
                showCancelModal={props.showCancelModal}
            />
        </>
    );
}

export default memo(UpiIntentPoller);
